import React, {useEffect} from 'react'

const Dashboard = () => {
    useEffect(() => {
        document.title="1Tostão | Dashboard"
    })

    return (
        <div>
            Dashboard
        </div>
    );
}
 
export default Dashboard;